import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { BaseCell } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton, TruncatedTextWithTooltip } from "@similarweb/ui-components";

export const StyledBaseCell = styled(BaseCell)`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const StyledContactNameText = styled(TruncatedTextWithTooltip)<{ isBlurred?: boolean }>`
    filter: ${({ isBlurred }) => (isBlurred ? "blur(4px)" : "unset")};
`;

export const StyledReportIconButton = styled(IconButton)<{ hasIssues?: boolean }>`
    flex-shrink: 0;

    ${SWReactIcons} {
        svg path {
            fill: ${({ hasIssues }) =>
                hasIssues ? colorsPalettes.red["400_P"] : colorsPalettes.carbon[300]} !important;
        }
    }
`;
